export default "/images/vendor/flag-icon-css/flags/4x3/gi.svg?345b700f04babfed53e1b6286d2ad511";